import React from 'react';

import { RadioButtonGroup } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';
import type { ChangedSortDetails } from 'src/components/organisms/ListingsControlsOptions/types';
import type { UISortOption } from 'src/components/types/UISortOption';

const SORT_ID = 'sortOptions';

interface SortOptionsProps {
  accessibleLabel: string;
  onSortOptionChange: (sortOptionDetails: ChangedSortDetails) => void;
  sortOptions: UISortOption[];
}

export const onChange = (
  radioButtonValue: string,
  sortOptions: UISortOption[],
  onSortOptionChange: (sortOptionDetails: ChangedSortDetails) => void,
) => {
  const option = sortOptions.find((option) => option.value === radioButtonValue);

  if (option) {
    onSortOptionChange({
      activeTitle: option.title,
      activeValue: option.value,
    });
  }
};

export const SortOptions = ({
  accessibleLabel,
  onSortOptionChange,
  sortOptions,
}: SortOptionsProps) => {
  return (
    <RadioButtonGroup
      accessibleLabel={accessibleLabel}
      hideLabel
      name={SORT_ID}
      onChange={(radioButtonValue: string) =>
        onChange(radioButtonValue, sortOptions, onSortOptionChange)
      }
      radioButtonData={sortOptions.map(({ active, title, value }) => ({
        checked: active,
        labelText: title,
        value,
      }))}
    />
  );
};
